interface PostData {
  selectedFile?: File | null;
  firstName?: string;
  lastName?: string;
  sex?: string;
  emailAddress?: string;
  phoneNumber?: string;
  bachelorDegree?: string;
  resume?: File | null;
}
    
interface FormValidation {
  postData: PostData;
  getAllEnrollmentUsers?: PostData[];
}

const postValidateSelectedFile = ({postData}: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.selectedFile) {
    errors.push('file cannot be empty');
    isValid = false;
  }
  return { isValid, errors };
};

const postValidateFirstName = ({ postData }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.firstName || postData.firstName.trim() === '') {
    errors.push('First name cannot be empty');
    isValid = false;
  } else if (postData.firstName.length < 2) {
    errors.push('First name must be at least 2 letters');
    isValid = true;
  } else if (!/^[a-zA-Z]+$/.test(postData.firstName)) {
    errors.push('First name must contain only letters, no numbers and no whitespaces');
    isValid = true;
  }
  return { isValid, errors };
};

const postValidateLastName = ({ postData }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.lastName || postData.lastName.trim() === '') {
    errors.push('Last name cannot be empty');
    isValid = false;
  } else if (postData.lastName.length < 2) {
    errors.push('Last name must be at least 2 letters');
    isValid = true;
  } else if (!/^[a-zA-Z]+$/.test(postData.lastName)) {
    errors.push('Last name must contain only letters, no numbers and no whitespaces');
    isValid = true;
  }
  return { isValid, errors };
};

const postValidateSex = ({postData}: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.sex || postData.sex.trim() === '') {
      errors.push('file cannot be empty');
      isValid = false;
  }

  return { isValid, errors };
};
  
const postValidateEmailAddress = ({ postData, getAllEnrollmentUsers }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;
  const emailRegex = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;

  if (!postData.emailAddress || postData.emailAddress.trim() === '') {
    errors.push('Email address cannot be empty');
    isValid = false;
  } else if (getAllEnrollmentUsers && getAllEnrollmentUsers.some(user => user.emailAddress === postData.emailAddress)) {
    errors.push('Email address already exist');
    isValid = true;
  } else if (!emailRegex.test(postData.emailAddress)) {
    errors.push('Invalid email address');
    isValid = true;
  }
  return { isValid, errors };
};

const postValidatePhoneNumber = ({ postData }: FormValidation) => {
    const errors: string[] = [];
    let isValid = false;
    const phoneRegex = /\d{3}-\d{3}-\d{5}/;
  
    if (!postData.phoneNumber || postData.phoneNumber.trim() === '') {
      errors.push('Phone Number cannot be empty');
      isValid = false;
    } else if (!phoneRegex.test(postData.phoneNumber)) {
      errors.push('Invalid primary phone, Phone format must be - 011-233-45678');
      isValid = true;
    }
    return { isValid, errors };
};

const postValidateResume = ({postData}: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.resume) { //remove the trim if you're uploading a file
      errors.push('file cannot be empty');
      isValid = false;
  }

  return { isValid, errors };
};

export {
  postValidateSelectedFile,
  postValidateFirstName,
  postValidateLastName,
  postValidateSex,
  postValidateEmailAddress,
  postValidatePhoneNumber,
  postValidateResume,
}